const override = false;
const config = {
    development: {
        FIREBASE: {
            apiKey: 'AIzaSyAbVVAyzRuw0Mx18DYczCehMsjWFCYX1Lo',
            authDomain: 'highlevel-staging.firebaseapp.com',
            databaseURL: 'https://highlevel-staging.firebaseio.com',
            projectId: 'highlevel-staging',
            storageBucket: 'highlevel-staging.appspot.com',
            messagingSenderId: '85350210461',
            appId: '1:85350210461:web:d3728d34bf8bd6b5',
        },
        APPENGINE_BASE_URL: 'https://staging.services.leadconnectorhq.com/appengine',
        LOCATION_SERVICE_URL: 'https://staging.services.leadconnectorhq.com',
        newBaseUrl: 'https://staging.services.leadconnectorhq.com/appengine',
        CONTACTS_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/contacts',
        WORKFLOW_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/workflow',
        CONVERSATIONS_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/conversations',
        OPPORTUNITIES_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/opportunities',
        CONVERSATION_AI_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/conversations-ai',
        CALENDARS_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/calendars',
        INVOICES: 'https://staging.services.leadconnectorhq.com/invoices',
        USE_VERSION: true,
        VERSION_DETAILS: {
            CONVERSATIONS_SERVICE_URL: 'https://staging.versionedservices.leadconnectorhq.com/conversations',
            DEVELOPER_VERSION: 'himanshu',
        },
        SAAS_BILLING: 'https://staging.services.leadconnectorhq.com/saas_billing',
        RESELLING: 'https://staging.services.leadconnectorhq.com/reselling',
        CDN_URL: 'https://staging.filesafe.space/',
    },
    staging: {
        FIREBASE: {
            apiKey: 'AIzaSyAbVVAyzRuw0Mx18DYczCehMsjWFCYX1Lo',
            authDomain: 'highlevel-staging.firebaseapp.com',
            databaseURL: 'https://highlevel-staging.firebaseio.com',
            projectId: 'highlevel-staging',
            storageBucket: 'highlevel-staging.appspot.com',
            messagingSenderId: '85350210461',
            appId: '1:85350210461:web:d3728d34bf8bd6b5',
        },
        APPENGINE_BASE_URL: 'https://staging.services.leadconnectorhq.com/appengine',
        LOCATION_SERVICE_URL: 'https://staging.services.leadconnectorhq.com',
        newBaseUrl: 'https://staging.services.leadconnectorhq.com/appengine',
        CONTACTS_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/contacts',
        WORKFLOW_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/workflow',
        CONVERSATIONS_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/conversations',
        OPPORTUNITIES_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/opportunities',
        CONVERSATION_AI_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/conversations-ai',
        INVOICES: 'https://staging.services.leadconnectorhq.com/invoices',
        CALENDARS_SERVICE_URL: 'https://staging.services.leadconnectorhq.com/calendars',
        USE_VERSION: true,
        VERSION_DETAILS: {
            CONVERSATIONS_SERVICE_URL: 'https://staging.versionedservices.leadconnectorhq.com/conversations',
            DEVELOPER_VERSION: 'himanshu',
        },
        SAAS_BILLING: 'https://staging.services.leadconnectorhq.com/saas_billing',
        RESELLING: 'https://staging.services.leadconnectorhq.com/reselling',
        CDN_URL: 'https://staging.filesafe.space/',
    },
    production: {
        FIREBASE: {
            apiKey: 'AIzaSyB_w3vXmsI7WeQtrIOkjR6xTRVN5uOieiE',
            authDomain: 'highlevel-backend.firebaseapp.com',
            databaseURL: 'https://highlevel-backend.firebaseio.com',
            projectId: 'highlevel-backend',
            storageBucket: 'highlevel-backend.appspot.com',
            messagingSenderId: '439472444885',
            appId: '1:439472444885:android:c48022009a58ffc7',
        },
        APPENGINE_BASE_URL: 'https://services.leadconnectorhq.com/appengine',
        LOCATION_SERVICE_URL: 'https://services.leadconnectorhq.com',
        newBaseUrl: 'https://services.leadconnectorhq.com/appengine',
        CONTACTS_SERVICE_URL: 'https://services.leadconnectorhq.com/contacts',
        WORKFLOW_SERVICE_URL: 'https://services.leadconnectorhq.com/workflow',
        CONVERSATIONS_SERVICE_URL: 'https://services.leadconnectorhq.com/conversations',
        CONVERSATION_AI_SERVICE_URL: 'https://services.leadconnectorhq.com/conversations-ai',
        CALENDARS_SERVICE_URL: 'https://services.leadconnectorhq.com/calendars',
        OPPORTUNITIES_SERVICE_URL: 'https://services.leadconnectorhq.com/opportunities',
        SAAS_BILLING: 'https://services.leadconnectorhq.com/saas_billing',
        RESELLING: 'https://services.leadconnectorhq.com/reselling',
        CDN_URL: 'https://assets.cdn.filesafe.space/',
        INVOICES: 'https://services.leadconnectorhq.com/invoices',
    },
};
if (override) {
    // do overrides here
}
export default config[process.env.mode];
